import type { ElementType, ForwardedRef } from 'react';
import { forwardRef } from 'react';

import * as Styled from './Stack.styled';
import type { StackComponentProps } from './types';

export const Stack = forwardRef(
  (
    {
      as,
      children,
      align = 'stretch',
      background,
      borderColor,
      borderStyle,
      borderWidth,
      direction,
      display = 'flex',
      flex = '0 1 auto',
      height,
      justify = 'flex-start',
      margin = 'none',
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      maxHeight,
      maxWidth,
      overflow = 'initial',
      padding = 'none',
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
      position,
      radius = 'none',
      spacing = 'none',
      width,
      ...rest
    }: Partial<StackComponentProps> & { as?: ElementType },
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <Styled.Stack
        ref={ref}
        $align={align}
        $background={background}
        $borderColor={borderColor}
        $borderStyle={borderStyle}
        $borderWidth={borderWidth}
        $direction={direction}
        $display={display}
        $flex={flex}
        $height={height}
        $justify={justify}
        $margin={margin}
        $marginBottom={marginBottom}
        $marginLeft={marginLeft}
        $marginRight={marginRight}
        $marginTop={marginTop}
        $maxHeight={maxHeight}
        $maxWidth={maxWidth}
        $overflow={overflow}
        $padding={padding}
        $paddingBottom={paddingBottom}
        $paddingLeft={paddingLeft}
        $paddingRight={paddingRight}
        $paddingTop={paddingTop}
        $position={position}
        $radius={radius}
        $spacing={spacing}
        $width={width}
        as={as}
        {...rest}
      >
        {children}
      </Styled.Stack>
    );
  },
);

Stack.displayName = 'Stack';
